module.exports = __webpack_public_path__ + "static/media/coffee-cup-heart-love-beans.c8f034ce.jpg";